import { CHAINS } from '../chains'
import type { Network } from '../types'

export function getNetworkFromChainId(chainId: number): Network | undefined {
  return CHAINS.find((chain) => chain.chainId === chainId)?.name
}
